import { supabase } from './supabase'
import type { BillingPlan, PaywallType } from './monetization'

export interface CheckoutSessionInput {
  plan: BillingPlan
  paywallType: PaywallType
  surface: string
  context?: Record<string, unknown>
}

export interface CheckoutSessionResponse {
  checkout_url: string
}

export interface CustomerPortalSessionResponse {
  link: string
}

async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}

async function requestBilling<T>(path: string, body: unknown = {}): Promise<T> {
  const token = await getAccessToken()
  const headers: HeadersInit = {
    'Content-Type': 'application/json'
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(path, {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  })

  const text = await response.text()
  const payload = text ? JSON.parse(text) : null

  if (!response.ok) {
    const message =
      payload?.error ||
      payload?.message ||
      `Billing request failed (${response.status})`
    throw new Error(message)
  }

  return payload as T
}

export async function createCheckoutSession(
  input: CheckoutSessionInput
): Promise<CheckoutSessionResponse> {
  return requestBilling<CheckoutSessionResponse>('/api/dodo/checkout', input)
}

export async function createCustomerPortalSession(): Promise<CustomerPortalSessionResponse> {
  return requestBilling<CustomerPortalSessionResponse>(
    '/api/dodo/customer-portal'
  )
}
